import { SiteCountry } from '../../data/models/locale'
import { store } from '../../store/store'

export function isActive() {
  const state = store.getState()
  return (
    [SiteCountry.nl, SiteCountry.be].includes(state.locale.country) &&
    new Date() < new Date(2019, 1, 5)
  )
}
